import { useEffect, useState } from 'react';
import { resolveDxTheme } from '../documentEditor/documentEditorUrls';

/** Live light/dark mode from `html[data-theme]`, including workspace iframe sync. */
export function useHtmlThemeMode(): 'light' | 'dark' {
  const [mode, setMode] = useState<'light' | 'dark'>(resolveDxTheme);

  useEffect(() => {
    const sync = () => setMode(resolveDxTheme());
    document.addEventListener('jarvis:theme-change', sync);
    const observer = new MutationObserver(sync);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme']
    });
    return () => {
      document.removeEventListener('jarvis:theme-change', sync);
      observer.disconnect();
    };
  }, []);

  return mode;
}
